import ChallengeProgressContainer from "@features/dashboard/containers/ChallengeProgressContainer";
import ProgressContainer from "@features/dashboard/containers/ProgressContainer";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import { useAppStore } from "@hooks/useAppStore";
import DocumentTitle from "components/DocumentTitle";
import { useTranslation } from "react-i18next";

const ProgressRoute = () => {
	const { t } = useTranslation();
	const isImageChallengeApp = useAppStore(
		(state) => state.app.isImageChallengeApp,
	);
	const title = t(isImageChallengeApp ? "navbar.insights" : "navbar.progress");

	return (
		<>
			<DocumentTitle title={title} />
			<AppBar title={title} />
			{isImageChallengeApp ? (
				<ChallengeProgressContainer />
			) : (
				<ProgressContainer />
			)}
		</>
	);
};

export default ProgressRoute;
